<p-calendar
  class="calendar-sider"
  [(ngModel)]="date14"
  [inline]="true"
  [showWeek]="false"
  (onSelect)="changeDate($event)"
></p-calendar>
